const section = document.querySelector('.concierge-section-four');
if (section) {

// ── TABS ────────────────────────────────────────────────────────────────────

const tabs          = Array.from(section.querySelectorAll('.concierge-section-four__tab'));
const panels        = Array.from(section.querySelectorAll('.concierge-section-four__panel'));
const panelsCont    = section.querySelector('.concierge-section-four__panels');
const tabsEl        = section.querySelector('.concierge-section-four__tabs');

function activateTab(index) {
    const current = panels.findIndex(p => p.classList.contains('is-active'));
    if (current === index) return;

    tabs.forEach((t, i) => t.classList.toggle('is-active', i === index));

    // lock height → swap → animate to new height → release
    panelsCont.style.height = panelsCont.offsetHeight + 'px';
    panels[current].classList.remove('is-active');
    panels[index].classList.add('is-active');

    requestAnimationFrame(() => {
        panelsCont.style.height = panels[index].scrollHeight + 'px';
        panelsCont.addEventListener('transitionend', () => {
            panelsCont.style.height = 'auto';
        }, { once: true });
    });
}

tabs.forEach((tab, i) => tab.addEventListener('click', () => activateTab(i)));

// tabs scroll mask (mobile)
function updateMask() {
    tabsEl.classList.toggle('is-start', tabsEl.scrollLeft <= 1);
    tabsEl.classList.toggle('is-end', tabsEl.scrollLeft >= tabsEl.scrollWidth - tabsEl.clientWidth - 1);
}
tabsEl.addEventListener('scroll', updateMask, { passive: true });
updateMask();

// init sans animation
panelsCont.style.transition = 'none';
panels[0].classList.add('is-active');
tabs[0].classList.add('is-active');
panelsCont.style.height = 'auto';
requestAnimationFrame(() => { panelsCont.style.transition = ''; });

// ── ACCORDÉONS ──────────────────────────────────────────────────────────────

    section.querySelectorAll('.concierge-section-four__question').forEach(btn => {
        btn.addEventListener('click', () => {
            const isOpen = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!isOpen));
        });
    });
}
